module.exports = __webpack_public_path__ + "static/media/icon-interactive.aa1c398e.svg";